import React, { Component } from 'react';
import { store } from 'Store/store.index';
import { Modal } from 'antd';
import {
  CheckCircleFilled
} from '@ant-design/icons';
import { observer } from 'mobx-react';
import './fwRegisterSaveSuccess.scss';
@observer
class fwRegisterSaveSuccess extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount () {
  }
  componentWillUnmount() {}
  closeModal(){
    store.office.getIsShowSaveSuccess(false);
  }
  render() {
    return (
      <React.Fragment>
        <Modal 
          visible={true}
          closable={false}
          className="registerModal"
          footer={null} 
          width="384px"
          height="170px">
            <div className='title'>
              <CheckCircleFilled style={{ fontSize: '24px', color: '#16AD99' }}/>
              <span>登记表已保存成功，在新窗口进行展示</span>
            </div>
            <div className='content'>
              您可以直接关闭该窗口或再次编辑，再次编辑后需要重新保存登记表
            </div>
            <div className='footer'>
              <button onClick={this.closeModal}>再次编辑</button>
            </div>
        </Modal>
        
      </React.Fragment>
    );
  }
}
export default fwRegisterSaveSuccess
